import styled, { css } from "styled-components";
import { NavLink } from "react-router-dom";

const LinkStyled = styled(NavLink)`
    align-self: flex-start;
    width: 100%;
    @media only screen and (min-width: ${props => props.theme.smallTablet}) {
        width: auto;
    }

    &.login {
        margin-left: 2rem;
    }

    &.cta-link {
        display: block;
        margin-top: 3rem;
        margin-bottom: 2rem;
        width: 30rem;
        padding-left: 3.5rem;

        &:after {
            display: none;
        }
        &:before {
            content: "";
            width: 1.5rem;
            height: auto;
            background-position: bottom 0.3rem right;
            position: absolute;
            left: 0rem;
            top: 0.1rem;
            bottom: 0;
            margin: auto;
            background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='14' height='10'%3E%3Cdefs%3E%3Cpath d='M9.277.222c-.188-.194-.5-.194-.694 0a.49.49 0 0 0 0 .687l3.52 3.52H.486c-.27 0-.486.216-.486.487a.49.49 0 0 0 .486.493h11.617l-3.52 3.514a.5.5 0 0 0 0 .694c.194.194.507.194.694 0l4.354-4.354a.48.48 0 0 0 0-.687L9.277.222z' id='A'/%3E%3C/defs%3E%3Cg transform='translate(0 .188)' fill-rule='evenodd'%3E%3Cmask id='B' fill='%23fff'%3E%3Cuse xlink:href='%23A'/%3E%3C/mask%3E%3Cg fill='%23006150'%3E%3Cuse fill-rule='nonzero' xlink:href='%23A'/%3E%3Cg mask='url(%23B)'%3E%3Cpath d='M0-2.187h14v14H0z'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
            background-size: 1.4rem;
            background-repeat: no-repeat;
            transform: rotate(180deg);
        }
    }
    &.warn {
        color: ${props => props.theme.red};
    }
`;
export default LinkStyled;
